module.exports = __webpack_public_path__ + "static/media/sr.bdad3d57.svg";